export const EXCHANGE_PROVIDER_STATUS = {
  CONNECTED: 'connected',
  NOT_CONNECTED: 'notConnected'
}

export const EXCHANGE_ACCOUNT_ACTION = {
  CHANGE: 'change',
  CONNECT: 'connect'
}

export const COE_BRAND_IDS = ['apple', 'sony', 'samsung']
